// extracted by mini-css-extract-plugin
export default {"formikChipInput":"style_formikChipInput__GqSal"};